import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "M21.544 1.54a1 1 0 0 0-1.414 0l2.829 2.828a1 1 0 0 0 0-1.414L21.544 1.54Z" }, null, -1), c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m3.864 23.544 11.579-10.245 7.516-7.517-4.243-4.242L11.2 9.056.955 20.634a1 1 0 0 0 .042 1.37l1.498 1.498a1 1 0 0 0 1.37.042ZM18.716 3.66l2.121 2.121-6.187 6.188-2.121-2.122 6.187-6.187Zm-7.197 7.298-9.13 10.317.834.833 10.316-9.129-2.02-2.02Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  c
];
function r(s, a) {
  return t(), o("svg", l, [...d]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
